import tarieven from '../../../../shared/tarieven.json'

/*
 * Het tarief, gelezen uit shared/tarieven.json — hetzelfde bestand dat de API
 * gebruikt (WP-08). Vite bakt het bij de build in de bundel; wijzigen betekent
 * dus opnieuw deployen, en dat is precies de bedoeling: het bedrag hoort een
 * gecontroleerde wijziging te zijn, geen instelling die iemand losstaand kan
 * omzetten.
 *
 * WAT HIER STAAT IS UITSLUITEND OM TE TONEN. De prijs die daadwerkelijk in
 * rekening wordt gebracht komt van de server (WP-11); een gemanipuleerd bedrag
 * in de POST wordt daar genegeerd. Deze module bepaalt niets, hij laat alleen
 * zien wat de server zal rekenen.
 */

export const tariefCenten = tarieven.tariefCenten

/** True zolang de opdrachtgever het bedrag niet heeft vastgesteld (O-02). */
export const tariefIsVoorlopig = tarieven.status !== 'definitief'

/** € 150,00 — Nederlandse notatie, met vaste decimalen. */
export function formatteerBedrag(centen: number): string {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: tarieven.valuta,
  }).format(centen / 100)
}

/** Het tarief als tekst, klaar om te tonen. */
export const tariefTekst = formatteerBedrag(tariefCenten)
